/**
 * Created by Jose Andres on 02.23.17
 */

export * from './car.theme';
export * from './default.theme';
export * from './digital.theme';
export * from './minimal.theme';
export * from './plaza.theme';
export * from './slot-machine.theme';
export * from './train-station.theme';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
